import {
  Receipt, ShoppingCart, Banknote, BookOpenCheck,
  FileSignature, Users, Car, Scale, ArrowRight
} from "lucide-react";

const MODULES = [
  {
    id: "sales", icon: Receipt, tag: "Ventes",
    title: "Facturation Factur-X 2026 ready",
    desc: "Devis, factures certifiées, avoirs, refacturation, relances SMS + email automatiques.",
    accent: "from-indigo-500/10 to-indigo-500/0",
    stat: "Encaissement +8 jours plus vite",
  },
  {
    id: "purchases", icon: ShoppingCart, tag: "Achats",
    title: "Factures fournisseurs OCR",
    desc: "OCR IA de vos factures, workflow bon-à-payer, détection des doublons et arnaques.",
    accent: "from-amber-500/10 to-amber-500/0",
    stat: "98% de saisie automatisée",
  },
  {
    id: "treasury", icon: Banknote, tag: "Trésorerie",
    title: "Multi-banques temps réel",
    desc: "Agrégation DSP2 (Bridge/Powens), rapprochement IA, prévisionnel glissant.",
    accent: "from-emerald-500/10 to-emerald-500/0",
    stat: "Runway calculé à la minute",
  },
  {
    id: "accounting", icon: BookOpenCheck, tag: "Comptabilité",
    title: "FEC & exports Cegid / Sage",
    desc: "Plan comptable, journaux automatisés, écritures d'à-nouveau, TVA.",
    accent: "from-blue-500/10 to-blue-500/0",
    stat: "Export FEC en 1 clic",
  },
  {
    id: "contracts", icon: FileSignature, tag: "Contrats",
    title: "Engagements SaaS & abonnements",
    desc: "Détection auto des récurrences bancaires, résiliation LRAR, alertes 90j.",
    accent: "from-purple-500/10 to-purple-500/0",
    stat: "-15% coûts SaaS 6 mois",
  },
  {
    id: "hr", icon: Users, tag: "RH & Paie",
    title: "Bulletins de paie IA",
    desc: "Extraction automatique période + salarié, DPAE, arrêts maladie, RUP.",
    accent: "from-rose-500/10 to-rose-500/0",
    stat: "Upload en masse en 30s",
  },
  {
    id: "fleet", icon: Car, tag: "Flotte",
    title: "Parc automobile & IK",
    desc: "Cartes grises OCR, sinistres, amendes, indemnités kilométriques, bilan carbone.",
    accent: "from-cyan-500/10 to-cyan-500/0",
    stat: "Amortissements auto-calculés",
  },
  {
    id: "legal", icon: Scale, tag: "Juridique",
    title: "Droit des sociétés",
    desc: "AGE/AGO pré-remplies, registres RBE et personnel, PV, coffre-fort eIDAS.",
    accent: "from-slate-500/10 to-slate-500/0",
    stat: "AGO générée en 3 min",
  },
];

export default function ModulesGrid() {
  return (
    <section
      id="modules"
      className="py-20 lg:py-28 bg-gradient-to-b from-[#F8FAFC] to-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#4F46E5]">
            8 modules · 1 base de données · 0 double saisie
          </div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B0F17] leading-tight">
            La suite financière complète, pensée comme un ERP moderne.
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Chaque module partage la même source de vérité — vos clients, vos
            fournisseurs, vos écritures. Vous n'entrez la même information qu'une
            seule fois.
          </p>
        </div>

        <div
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
          data-testid="modules-grid"
        >
          {MODULES.map((m) => {
            const Icon = m.icon;
            return (
              <div
                key={m.id}
                className="group relative rounded-2xl border border-slate-200 bg-white p-6 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-900/[0.06] hover:border-slate-300"
                data-testid={`module-card-${m.id}`}
              >
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${m.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`}
                />
                <div className="relative">
                  <div className="flex items-center justify-between">
                    <div className="h-10 w-10 rounded-xl bg-slate-50 border border-slate-100 grid place-items-center text-[#0B0F17]">
                      <Icon className="h-5 w-5" strokeWidth={1.75} />
                    </div>
                    <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">
                      {m.tag}
                    </span>
                  </div>
                  <h3 className="mt-5 font-bold text-[#0B0F17] leading-snug">
                    {m.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {m.desc}
                  </p>
                  <div className="mt-5 pt-4 border-t border-dashed border-slate-200 flex items-center justify-between">
                    <span className="text-xs font-semibold text-emerald-600">
                      {m.stat}
                    </span>
                    <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-[#0B0F17] group-hover:translate-x-0.5 transition-all" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
